import { Flex } from 'foundations-components/components/Flex';
import { useTableSelector } from '../../redux/reduxHooks';
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { getShouldShowBulkActionsContainer } from '../../selection/redux/selectionSlice';
import { TABLE_TOP_BAR_HEIGHT } from '../constants/sizes';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TableTopBar({
  alternateHeaderLeftSlot,
  BulkActionsComponent,
  headerLeftSlot,
  headerRightSlot,
  isBulkActionsRedesignEnabled,
  isIndexRedesignEnabled,
  showSelectQuery,
  totalRowCount
}) {
  const shouldShowBulkActions = useTableSelector(getShouldShowBulkActionsContainer);
  const shouldOnlyShowBulkActions = shouldShowBulkActions && isBulkActionsRedesignEnabled;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    backgroundColor: "fill-field-default",
    blockSize: TABLE_TOP_BAR_HEIGHT,
    borderColor: "border-core-subtle",
    borderStyle: "solid",
    borderWidth: "100",
    borderBlockEndStyle: "none",
    "data-test-id": "table-top-bar",
    flexBasis: TABLE_TOP_BAR_HEIGHT,
    inlineSize: "100%",
    justifyContent: isBulkActionsRedesignEnabled ? 'space-between' : 'start',
    children: shouldOnlyShowBulkActions ? /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      showSelectQuery: showSelectQuery,
      totalRowCount: totalRowCount
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [headerLeftSlot, !shouldShowBulkActions && alternateHeaderLeftSlot, shouldShowBulkActions && /*#__PURE__*/_jsx(BulkActionsContainer, {
        BulkActionsComponent: BulkActionsComponent,
        isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
        isIndexRedesignEnabled: isIndexRedesignEnabled,
        showSelectQuery: showSelectQuery,
        totalRowCount: totalRowCount
      }), /*#__PURE__*/_jsx(View, {
        marginInlineStart: "auto",
        as: "div",
        children: headerRightSlot
      })]
    })
  });
}
export default TableTopBar;